import { z } from 'zod';
import { createSortablePaginationSchema } from '../../../shared/index.js';
export const PUBLIC_DOCUMENT_SOURCE_TYPES = ['legislative_item', 'meeting_event'];
export const publicDocumentsFullSearchBodySchema = z.object({
    query: z.string().default(''),
    limit: z.number().int().min(1).max(50).default(20),
    offset: z.number().int().min(0).default(0),
    sourceType: z.enum(PUBLIC_DOCUMENT_SOURCE_TYPES).optional(),
    /** ISO date string — only return documents whose meeting date is on or after this date */
    meetingDateAfter: z.iso.date().optional(),
    /** ISO date string — only return documents whose meeting date is on or before this date */
    meetingDateBefore: z.iso.date().optional(),
});
export const publicDocumentsGetSchema = z.object({
    year: z.string().regex(/^\d{4}$/),
});
export const publicDocumentFilterOptionsQuerySchema = z.object({
    year: z
        .string()
        .regex(/^\d{4}$/)
        .optional(),
});
export const publicDocumentsSearchSchema = createSortablePaginationSchema(['createdAt'])
    .extend(publicDocumentsGetSchema.shape)
    .extend({ documentTypeId: z.number().int().positive().optional() });
